import type { ItemType } from '@brickloop/core/schemas';
import { ORDER_STATUS_LABEL } from '@brickloop/core/schemas';
import type { OrderStatus } from '../api';

export const TYPE_LABEL: Record<ItemType, string> = {
  PART: 'Part',
  SET: 'Set',
  MINIFIG: 'Minifigure',
  BOOK: 'Book',
  GEAR: 'Gear',
  CATALOG: 'Catalogue',
  INSTRUCTION: 'Instructions',
  ORIGINAL_BOX: 'Original box',
  UNSORTED_LOT: 'Unsorted lot',
};

export const statusLabel = (s: OrderStatus): string => ORDER_STATUS_LABEL[s];

/** Orders still expected are blue, finished ones green, and the ones that fell through slate. */
export const statusTone = (s: OrderStatus): 'slate' | 'green' | 'amber' | 'red' | 'blue' =>
  s === 'received' ? 'green' : s === 'cancelled' ? 'slate' : s === 'closed' ? 'amber' : s === 'partially_received' ? 'amber' : 'blue';
